<template>
    <div class="notes-dialog">
        <el-dialog :visible.sync="notesOpen" 
        append-to-body
        width="80vw"
        :close-on-click-modal="true"
        class="send-modal">
            <div slot="title" class="bucket-header">
                <img class="event-chevron" style="width: 57px" :src="require('../image/ctc-event.png')" /> 
                {{ name }}
                <span class="bucket-provider">
                    {{ date }}
                </span>
                <span class="bucket-provider">
                    {{ providerName }}
                </span>
                <span class="flex-full"></span>


                <button class="copy-button" @click="copyToClip()" :disabled="isAnyChartEdited">
                    <i class="el-icon-copy-document"></i> Copy All
                </button>


                <el-tooltip :disabled="!combNoteDisabled" class="push-btn-container" content="Disabled for manually created events">
                    <button class="push-button" v-popover:popover
                        v-if="hasPushIntegration && emrCategory.length == 0"
                        :disabled="combNoteDisabled || (integration ? integration.combined_notes_push_to_emr.default : false)"
                        @click="saveEmrNote({ emrId: 'default'})">
                        {{ pushing ? 'Pushing' : 'Push All' }} <i class="el-icon-arrow-down"></i>
                    </button>

                    <el-dropdown v-else-if="hasPushIntegration && emrCategory.length > 0"
                            @command="emrSelected" v-popover:popover :disabled="isAnyChartEdited">
                        <button :disabled="combNoteDisabled" class="push-button">
                            {{ pushing ? 'Pushing...' : 'Push All' }}  <i class="el-icon-arrow-down" style="font-size: 12px"></i>
                        </button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item
                                :key="emr.id"
                                v-for="emr in emrCategory"
                                placement="bottom"
                                :command="{ emrId: emr.id, emrTitle: emr.title}">
                                <div class="dropdwn-cnt">
                                    <span class="option-title">{{ emr.title }} </span>
                                    <span v-if="emr.last_pushed && emr.last_pushed !== ''" class="timestamp">
                                        <span id="content1" style="line-height: 13px; margin-top: 10px" v-html="getFormattedLastPushed(emr.last_pushed)"></span>
                                    </span>
                                </div>
                            </el-dropdown-item>
                            <span class="info" v-if="emrCategory.some(({disabled}) => disabled)">
                                <img :src="require('../image/info-icon.png')" />
                                Notes have been Pushed to {{ emrCategory.filter((emr) => emr.disabled).map(({ title }) => `'${title}'`).join(', ') }}
                            </span>
                        </el-dropdown-menu>
                    </el-dropdown>

                </el-tooltip>


            </div>
            <p v-if="hasPushIntegration" class="last-pushed-string">{{ getLastPushedBucketCategoryText }}</p>
            <div class="dialog-body" v-if="isEveryQuestionChartVersioned">
                <div class="event-list">
                    <NotesDialogChart 
                        v-for="(note, index) in notes"
                        :key="index"
                        v-model="isNoteSelectedOrEditedMap[note.id]"
                        :note="note"
                        :patient="patient"
                        :notes-version="getLatestNoteVersion(note.id)"
                    />
                </div>
                
            </div>
            <div class="dialog-body" v-else>
                <div class="event-list">
                    <span class="" v-for="(note, index) in notes"
                        :key="note.id">
                        <el-checkbox v-model="isNoteSelected[index]" class="questionnaire-checkbox">{{ note.title }}</el-checkbox>
                    </span>
                </div>
                <div class="notes">
                    <TextEdit 
                        :key="renderKey"
                        class="text-edit expanded"
                        :textEditId="schedule"
                        v-model="copyNotes"
                        @text-selected="partialNoteSelected"
                    ></TextEdit>
                </div>
            </div>
        </el-dialog>
        <button @click="notesOpen = true" class="notes-button" type="text" size="medium">
            <i class="el-icon-view"></i> View All
        </button>
    </div>
    
</template>

<script>
import { mapActions, mapState } from 'vuex'

import CopyMixin from './mixin/copy'

import TextEdit from '@/module/component/TextEdit'
import NotesDialogChart from './NotesDialogChart'
import formatDateTime from '@/module/util/format-date-time'

export default {
    name: 'notes-dialog',

    mixins: [CopyMixin],

    props: {
        patient: {
            type: Object,
            required: true
        },
        notes: {
            type: Array,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        providerName: {
            type: String,
            required: true
        },
        date: {
            type: String,
            required: true
        },
        integration: {
            type: Object,
        },
        hasPushIntegration: {
            type: Boolean,
            required: true
        },
        emrCategory: {
            type: Array,
            required: true
        },
        provider: {
            type: String,
            required: true
        },
        schedule: {
            type: String,
            required: true
        },
        combNoteDisabled:  {
            type: Boolean,
            required: true
        },
        chartMapForPatient: {
            type: Object,
            required: true
        }
    },

    watch: {
        isNoteSelected: {
            handler: function () {
                this.copyNotes = this.notes.filter((_, idx) => this.isNoteSelected[idx])
                    .map(({result}) => result.replaceAll('\n', '<br>')).join(' <br> -- <br> <br> ')
                this.renderKey += 1
                if (this.copyNotes.length === 0)
                    this.copyNotes = '<span style="color: #da4e4e" >Select Questionnaire to show Chart Notes</span>'
            },
            deep: true
        }
    },


    data() {
        return {
            notesOpen: false,
            copyNotes: this.notes.map(({result}) => result.replaceAll('\n', '<br>')).join(' <br> -- <br> <br> '),
            pushing: false,
            copiedNote: null,
            partiallyCopiedNote: false,
            copiedNoteDupl: null,
            partiallyCopiedNoteDupl: false,
            showPopOver: false,
            selectedEMRData : {},
            isNoteSelected: this.notes.map(_ => true),
            // An object of `isNoteSelected` with id as key
            isNoteSelectedOrEditedMap: this.notes.reduce((acc, {id}) => {
                acc[id] = {
                    selected: true,
                    edited: false
                }
                return acc
            }, {}),
            renderKey: 0,
            foundEmpty: false
        }
    },

    methods: {
        ...mapActions('provider', ['pushNoteCategory', 'loadPatient', 'pushNewNoteCategory']),
        formatDateTime,
        copyToClip() {
            if(this.isEveryQuestionChartVersioned) {
                const copyNotes = this.notes.filter(({id}) => this.isNoteSelectedOrEditedMap[id].selected)
                    .map(({id}) => this.getLatestNoteVersion(id).text.replaceAll('\n', '<br>')).join(' <br> <br> ')
                this.copy(copyNotes)
                return
            }
            this.copy(this.copyNotes)
        },
        getFormattedLastPushed(lastPushed) {
            let arr = lastPushed.split(' ')
            if (arr.length === 5)
                return 'Last: ' + arr.slice(0, 3).join(' ') + '<br>' + arr.slice(3, 6).join(' ')
            return lastPushed
        },
        emrSelected(data) {
            if(this.isEveryQuestionChartVersioned) {
                this.newSaveEmrNote(data)
                return
            }
            this.selectedEMRData = data
            if(this.partiallyCopiedNote && !this.partiallyCopiedNoteDupl) {
                this.showPopOver = true
                this.copiedNoteDupl = this.copiedNote
                this.partiallyCopiedNoteDupl = this.partiallyCopiedNote
            }
            else this.saveEmrNote(this.selectedEMRData)
        },
        saveEmrNote(emrData) {
            const queryData = {
                schedule: this.schedule,
                id: this.patient.id,
                provider: this.provider,
                emrs: [{
                    emr_category: emrData.emrId,
                    combined_notes: this.partiallyCopiedNoteDupl ? this.copiedNoteDupl.replace(/<\/?[Bb][Rr]>\s?/g, '\n').replace( /(<([^>]+)>)/ig, '') : this.copyNotes.replace(/<\/?[Bb][Rr]>\s?/g, '\n').replace( /(<([^>]+)>)/ig, '')
                }]
            }
            this.pushing = true
            this.pushNoteCategory(queryData)
                .then((response) => {
                    if(this.partiallyCopiedNote) {
                        this.$message({
                            message: response.success ? ('Pushed to ' + emrData.emrTitle) : ('Failed to push to ' + emrData.emrTitle),
                            type: response.success ? 'success' : 'error'
                        })
                    } else {
                        this.notesOpen = false
                        this.$message({
                            message: response.description,
                            type: response.success ? 'success' : 'error'
                        })
                    }
                }).catch((error) => {
                    if(!error.success)
                        this.$message.error(error.description)
                }).finally((_) => {
                    this.pushing = false
                    this.copiedNote = null
                    this.partiallyCopiedNote = false
                    this.copiedNoteDupl = null
                    this.partiallyCopiedNoteDupl = false
                    this.showPopOver = false
                    this.selectedEMRData = {}
                })
        },
        newSaveEmrNote(emrData) {
            const questionnaire = []
            this.notes.forEach(note => {
                if(this.isNoteSelectedOrEditedMap[note.id].selected)
                    questionnaire.push(note.id)
            })
            const query = {
                id: this.patient.id,
                provider: this.provider,
                emr_category: emrData.emrId,
                questionnaire
            }
            this.pushing = true
            this.pushNewNoteCategory(query)
                .then((response) => {
                    this.showLocal = false
                    this.$message({
                        message: `Pushed to ${emrData.emrTitle}`,
                        type: 'success'
                    })
                }).catch((error) => {
                    if(!error.success)
                        this.$message.error("Problem pushing to EMR")
                }).finally((_) => this.pushing = false)
        },
        partialNoteSelected(partNote, noteId, clickedOut) {
            if(partNote == null && clickedOut) {
                this.copiedNote = null
                this.partiallyCopiedNote = false
                this.copiedNoteDupl = null
                this.partiallyCopiedNoteDupl = false
            } else if(partNote == null && !clickedOut) {
                this.copiedNoteDupl = null
                this.partiallyCopiedNoteDupl = false
            } else {
                this.copiedNote = partNote.replaceAll('\n', '<br>')
                this.partiallyCopiedNote = true
                this.copiedNoteDupl = partNote.replaceAll('\n', '<br> <br>')
                this.partiallyCopiedNoteDupl = true
            }
        },
        confirmParPushEmr() {
            this.showPopOver = false
            this.copiedNoteDupl = this.copiedNote
            this.partiallyCopiedNoteDupl = this.partiallyCopiedNote
            this.saveEmrNote(this.selectedEMRData)
        },
        cancelParPushEmr() {
            this.showPopOver = false
            this.copiedNote = null
            this.partiallyCopiedNote = false
            this.copiedNoteDupl = null
            this.partiallyCopiedNoteDupl = false
        },
        getLatestNoteVersion(noteId) {
            const chartMap = this.chartMapForPatient[noteId]
            return chartMap[chartMap.length - 1]
        }
    },

    computed: {
        getLastPushedBucketCategoryText() {
            let latestDate = 0
            let category = ''
            if (this.integration && this.integration.hasOwnProperty('combined_notes_push_to_emr')) {
                Object.keys(this.integration.combined_notes_push_to_emr).forEach(cat => {
                    if (latestDate < this.integration.combined_notes_push_to_emr[cat].last_pushed) {
                        latestDate = this.integration.combined_notes_push_to_emr[cat].last_pushed
                        category = cat
                    }

                })
            }
            this.notes.forEach(note => {
                if (note.integration && note.integration.push_to_emr) {
                    Object.keys(note.integration.push_to_emr).forEach(cat => {
                        if (latestDate < note.integration.push_to_emr[cat].last_pushed) {
                            latestDate = note.integration.push_to_emr[cat].last_pushed
                            category = cat
                        }
                    })
                }
            })
            let emrTitle = category
            this.emrCategory.forEach(emrs => {
                if (emrs.id === category)
                    emrTitle = emrs.title
            })
            if (latestDate)
                return 'Last Pushed to ' + emrTitle + ' at ' + formatDateTime(latestDate)
            else return ''
        },
        getNotesChartVersion() {
            return this.notes.map(({id}) => this.chartMapForPatient[id])
        },
        isEveryQuestionChartVersioned() {
            return this.notes.every(({id}) => this.chartMapForPatient[id].length > 0)
        },
        isAnyChartEdited() {
            return Object.values(this.isNoteSelectedOrEditedMap)
                .filter(({selected}) => selected)
                .some(({edited}) => edited)
        }
    },

    components: {
        TextEdit,
        NotesDialogChart
    }
}
</script>

<style lang="scss" scoped>
@import './style.scss';

.dialog-body {
    background-color: #F8F8F8;
    margin-top: -5px;
    width: calc(80vw - 40px);
    padding: 20px;
    border-radius: 7px;
}

.el-checkbox {
    font-weight: 600;
}

.bucket-header {
    background-color: transparent;
}
.notes-dialog {
    margin-right: 15px;
}
.last-pushed-string {
    float: right;
    margin-top: -27px;
    font-size: 12px;
    color: #666666;
}
.notes-button, .notes-button:hover {
    font-size: 13px;
    border: 1px solid #000;
    margin-left: 10px;
    border-radius: 5px;
    padding: 6px 8px !important;
    i {
        font-size: 13px;
		margin-right: 3px;
    }
}
.push-btn-container {
    float: right;
}
.push-button, .push-button:hover {
    font-size: 13px;
    font-weight: 500;
    color: #833e93;
    height: 28px;
    margin-left: 10px;
    background-color: #FAF5FC;
    border: 1px solid #833e93;
    border-radius: 5px;
    padding: 7px 8px !important;
    i {
        font-size: 11px;
        color: #833e93;
    }
}

.push-button:disabled {
    border-color: #B2B2B2;
    color: #B2B2B2;
    background-color: #EEEEEE;
    i {
        color: #B2B2B2;
    }
}
.notes {
    background-color: #ffffff;
    border-radius: 10px;
    padding-top: 12px;
    padding-bottom: 12px;
    line-height: 24px;
}
.event-head {
    display: flex;
    font-size: 14px;
    font-weight: 700;
    margin-bottom: 10px;
    span:first-child {
        padding-left: 0;
    }
    span {
        padding: 0px 12px;
    }
}
.event-list {
    word-break: break-word;
    margin-bottom: 12px;
    span {
        margin-right: 30px;
        line-height: 32px;
    }
}

.info {
    display: flex;
    background-color: #FFF3E3;
    color: #FA9E25;
    margin-bottom: -10px;
    padding: 8px 12px;
    font-size: 12px;
    max-width: 200px;
    img {
        height: 10px;
        width: 10px;
        margin-right: 5px;
    }
}

.dropdwn-cnt{
    display: inline-block;
    height: 45px !important;
    min-width: 250px;
}

.option-title {
    display: inline-block;
    margin-top: 14px;
    width: 70%;
    line-height: 1.4;
}
.timestamp{
    color: #999999;
    font-size: 10px;
    width: 35%;
    position: absolute;
    right: 10px;
    display: inline-block;
    text-align: right;

    span {
        height: 15px;
        display: block;
    }
}
.inl-blk {
    display: inline-block;
}
.pop-btn-grp {
    margin-left: 20px
}
</style>


<style scoped>
.send-modal >>> .el-dialog__headerbtn {
    top: 0px;
    right: -40px;
    background-color: #ffffff;
    border-radius: 50%;
    padding: 5px 5px 3px 5px;
}
.send-modal >>> .el-dialog__close:hover {
	font-weight: bold;
}
.send-modal >>> .el-dialog__close {
	color: #333333;
    font-size: 15px;
    font-weight: 500;
}
.send-modal >>> .el-dialog__headerbtn:hover .el-dialog__close {
	font-size: 15px;
    font-weight: 500;
}
.cust-pop-class {
    min-width: 520px;
}
.text-edit >>> b{
    color: #833e93;
}
.footer-btn >>> span {
    display: flex;
    align-items: center;
}
</style>
